(() => {
  if (window.nuitWeightGuideReady) return;
  window.nuitWeightGuideReady = true;
  const locale = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 });
  const weightOf = link => Number(link.dataset.weightLabel.match(/(\d+(?:[.,]\d+)?)\s*kg\b/i)?.[1]?.replace(',', '.'));
  const setupRange = root => {
    root.querySelectorAll('[data-nl-guide] [data-np-range]').forEach(wrapper => { wrapper.hidden = false; });
  };
  setupRange(document);
  document.addEventListener('shopify:section:load', event => setupRange(event.target));

  function update(guide) {
    const form = guide.querySelector('[data-weight-form]');
    const result = guide.querySelector('[data-result]');
    result.replaceChildren();
    if (!form.checkValidity()) return;
    const mass = form.querySelector('input[type=number]').valueAsNumber;
    const links = [...guide.querySelector('[data-variants]').content.querySelectorAll('a')];
    const weights = links.length ? [...new Set(links.map(weightOf).filter(Number.isFinite))] : [7, 11];
    const matches = weights.filter(kg => kg * 100 >= mass * 8 && kg * 100 <= mass * 12).sort((a, b) => a - b);
    const summary = document.createElement('div');
    summary.className = 'np-weight-feedback';
    const title = document.createElement('strong');
    title.textContent = 'Pour ' + locale.format(mass) + ' kg · repère de ' + locale.format(mass * .08) + ' à ' + locale.format(mass * .12) + ' kg';
    const note = document.createElement('p');
    note.textContent = matches.length ? 'Dans ce repère pour Céleste : ' + matches.join(' ou ') + ' kg.' : 'Aucun des lests de Céleste ne se situe dans cette plage.';
    summary.append(title, note);
    result.append(summary);
    if (!matches.length) return;

    const compareLinks = document.createElement('ul');
    compareLinks.className = 'np-match-actions';
    matches.forEach(kg => {
      const link = document.createElement('a');
      link.href = (document.getElementById('par-poids') ? '' : guide.dataset.compareUrl) + '#lest-' + kg;
      link.textContent = 'Comparer en ' + kg + ' kg';
      const row = document.createElement('li');
      row.append(link);
      compareLinks.append(row);
    });
    result.append(compareLinks);

    const available = links.filter(link => link.dataset.available === 'true' && matches.includes(weightOf(link)));
    if (!available.length) {
      const stock = document.createElement('p');
      stock.textContent = 'Aucune variante correspondante de Céleste n’est disponible à la commande.';
      result.append(stock);
      return;
    }
    const choices = document.createElement('details');
    const heading = document.createElement('summary');
    heading.textContent = 'Voir les variantes disponibles de Céleste (' + available.length + ')';
    const list = document.createElement('ul');
    available.forEach(link => {
      const row = document.createElement('li');
      row.append(link.cloneNode(true));
      list.append(row);
    });
    choices.append(heading, list);
    result.append(choices);
  }

  document.addEventListener('input', event => {
    const guide = event.target.closest('[data-nl-guide]');
    if (!guide) return;
    const number = guide.querySelector('input[type=number]');
    const range = guide.querySelector('input[type=range]');
    if (range && event.target === range) number.value = range.value;
    if (range && event.target === number && number.validity.valid) range.value = number.value;
    const error = guide.querySelector('[data-weight-error]');
    number.setAttribute('aria-invalid', String(!number.validity.valid));
    if (error) error.hidden = number.validity.valid;
    if (guide.dataset.calculated === 'true') update(guide);
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-weight-form]')) return;
    event.preventDefault();
    const guide = event.target.closest('[data-nl-guide]');
    if (event.target.reportValidity()) {
      guide.dataset.calculated = 'true';
      update(guide);
    }
  });
})();

